module.exports = __webpack_public_path__ + "img/lasexta.004aa89c.svg";